export default __webpack_public_path__ + "static/media/mikesap.6843896a.pdf";